document.addEventListener('DOMContentLoaded', () => {
  const allAtc = document.querySelector('.section-product-shop-the-look .js-product-form.atc-add-all');
  const allItem = Array.from(document.querySelectorAll('.section-product-shop-the-look__product-item'));
  const allAtcs = allItem
    .map((item) => item.querySelector('.js-product-form'))
    .filter(Boolean);

  allItem.forEach((item) => {
    const atc = item.querySelector('.section-product-shop-the-look__product-atc')
    const variant = item.querySelector('.section-product-shop-the-look__variant-select');
    const id = atc.querySelector('input[name="id"]');

    if (variant) {
      variant.addEventListener('change', () => id.value = variant.value);
    }
  });

  if (!allAtc) return;

  allAtc.addEventListener('submit', (event) => {
    event.preventDefault();
    (async () => {
      for (const form of allAtcs) {
        await new Promise(resolve => {
          form.requestSubmit();
          setTimeout(resolve, 600);
        });
      }
    })();
  });
});
